/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Lib dependencies
import { useTranslation } from 'react-i18next';

// UI lib dependencies
import { Stack, Text } from '@mantine/core';

// Styles
import classes from './WelcomeMessage.module.css';
import toLower from 'lodash/toLower';
import startCase from 'lodash/startCase';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const WelcomeMessage = (props: {
	username: string;
}) => {
	/* ********************************** HOOKS ********************************* */

	// I18n
	const { t } = useTranslation();

	const { username } = props;

	return (
		<Stack gap={'0px'}>
			<Text className={classes.textHello}>
				{t('dashboard.header.hello')}{' '}
				<Text
					span
					className={classes.textUsername}
					inherit
				>
					{startCase(toLower(username))}
				</Text>{' '}
				👋
			</Text>
			<Text className={classes.textDescription}>
				{t('dashboard.header.description')}
			</Text>
		</Stack>
	);
};
